import React, { useState, useEffect } from "react";
import { Typography, Paper } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import { Link, useLocation } from 'react-router-dom';
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import EditIcon from "@material-ui/icons/Edit";
import BiztranControls from "../../biztran_controls/BiztranControls";
import ModalFrame from "../../biztran_controls/Modal_Frame";
import CreateDeliveryChallan from "./CreateDeliveryChallan";
import axios from 'axios';
import { REPORT_URL } from "../../../Global";
//10-feb-change
import UseFetchData from "../../../hooks/UseFetchData";
import CourierDetails from "../DeliveryChallan/CourierDetails";
import CreatePOD from "../DeliveryChallan/CreatePOD";
import Button from '../../biztran_controls/Button';



const XLSX = require('xlsx');
const DCHeaderView = ({ DCMainData, DeliveryChallanID, PopulateData }) => {
    const classes = useStyles();
    const [rows, setrows] = useState([]);
    const [isOpen, setOpen] = useState(false);
    const [Mode, setMode] = useState('');
    const [DCID, SetDCID] = useState('');
    const [viewPath, setViewPath] = useState('');
    const [DCNo, setDCNo] = useState("");
    const [Company, setCompany] = useState("");
    const [DCDate, setDCDate] = useState("");
    const [AccountName, setAccountName] = useState("");
    const [Contact, setContact] = useState("");
    const [ContactNo, setContactNo] = useState("");
    const [LeadSource, setLeadSource] = useState("");
    const [DCType, setDCType] = useState("");
    const [BillAddress, setBillAddress] = useState("");
    const [BillCountry, setBillCountry] = useState("");
    const [BillState, setBillState] = useState("");
    const [BillCity, setBillCity] = useState("");
    const [BillPINCode, setBillPINCode] = useState("");
    const [ShipAddress1, setShipAddress1] = useState("");
    const [ShipAddress2, setShipAddress2] = useState("");
    const [ShipCity, setShipCity] = useState("");
    const [ShipPINCode, setShipPINCode] = useState("");
    const [ShipCountry, setShipCountry] = useState("");
    const [ShipState, setShipState] = useState("");
    const [HandledBy, setHandledBy] = useState("");
    const [GeneratedBy, setGeneratedBy] = useState("");
    const [CreatedBy, setCreatedBy] = useState("");
    const [TotalAmount, setTotalAmount] = useState("");
    const [ComboDataResponse, fetchComboData] = UseFetchData();
    const [cmbLeadSourceData, setcmbLeadSourceData] = useState([]);
    const [cmbCountryData, setcmbCountryData] = useState([]);
    const [cmbCompanyData, setcmbCompanyData] = useState([]);
    const [isCourierOpen, setCourierOpen] = useState(false);
    const [isPODOpen, setPODOpen] = useState(false);
    const [CourierDtlsUpdatedByID, setCourierDtlsUpdatedByID] = useState([]);
    const [PODUpdatedByID, setPODUpdatedByID] = useState([]);
    const [response, fetchData] = UseFetchData();
    const location = useLocation();
    var Account = location.state.AccountName;


    const handleOpenModal = () => {
        setOpen(true);
        SetDCID(DeliveryChallanID);
        setMode('Update');
    };

    const handleCourierOpenModal = () => {
        setCourierOpen(true);
        SetDCID(DeliveryChallanID);
        setCourierDtlsUpdatedByID('');
        setMode('Update');
    };

    const handlePODOpenModal = () => {
        setPODOpen(true);
        SetDCID(DeliveryChallanID);
        setPODUpdatedByID('');
        setMode('Update');
    };

    const OpenModal = () => {
        setOpen(true);
        SetDCID("");
        setMode('Insert');
    };

    useEffect(() => {
        //10-feb-change
        GetComboData();
    }, []);

    const Openurl = async () => {
        // debugger;
        axios.post('http://pmcrm.rpt.biztran.in/WebService.asmx/PrintReport', {
            PKID: DeliveryChallanID,
            Type: 'DeliveryChallan'
        })
            .then(await function (response) {
                // debugger;
                console.log(response.data);
                setViewPath(response.data);
                window.open(response.data);
            })
            .catch(function (error) {
                alert('error to print')
                console.log(error);
            });
        //
    }


    const GetComboData = () => {
        //10-feb change
        fetchComboData("DeliveryChallan/ComboDataHeader");
    };


    const uploadExcel = () => {
        var UpdatedByID = sessionStorage.UID;
        var bodyFormData = new FormData();
        bodyFormData.append("DeliveryChallanID", DeliveryChallanID);
        fetchData("Product/ProductBulk", bodyFormData);

    }

    useEffect(() => {
        //10-feb change
        if (ComboDataResponse !== undefined) {
            if (
                ComboDataResponse["LeadSource"] !== undefined &&
                ComboDataResponse["Country"] !== undefined
            ) {
                setcmbLeadSourceData(ComboDataResponse["LeadSource"]);
                setcmbCountryData(ComboDataResponse["Country"]);
                setcmbCompanyData(ComboDataResponse["Company"]);

            }
        }
    }, [ComboDataResponse]);

    const generateExcel = () => {
        // const data = [{
        //     ModelCode: "", SKU_Description: "", SKU_Specifications: "", Shipping_Weight: "", Unit: "", "List Price(INR)": "", "List Price(USD)": "", "Net Weight": ""
        // }];
        debugger;
        var data = [];
        const fileName = "DC.xlsx"
        const workbook = XLSX.utils.book_new();
        const sheet = XLSX.utils.json_to_sheet(data);
        XLSX.utils.book_append_sheet(workbook, sheet, "Sheet1");
        const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const element = document.createElement("a");
        const file = new Blob([wbout], { type: "application/octet-stream" });
        element.href = URL.createObjectURL(file);
        element.download = fileName;
        document.body.appendChild(element);
        element.click();
    };

    useEffect(() => {
        // debugger;
        if (DCMainData !== undefined && DCMainData.length > 0) {
            setCreatedBy(DCMainData[0].CreatedBy);
            setAccountName(DCMainData[0].AccountName);
            // setTotalAmount(DCMainData[0].TotalAmount);
            setDCNo(DCMainData[0].DeliveryChallanNo);
            setCompany(DCMainData[0].CompanyCode);
            setDCDate(DCMainData[0].DeliveryChallanDate);
            // setContact(DCMainData[0].ContactName);
            setContactNo(DCMainData[0].Mobile);
            // setLeadSource(DCMainData[0].LeadSource);
            // setDCType(DCMainData[0].DeliveryChallanType);
            setHandledBy(DCMainData[0].HandledBy);
            setGeneratedBy(DCMainData[0].GeneratedBy);
            setBillAddress(DCMainData[0].BillAddress1 === null ? "" : DCMainData[0].BillAddress1 + " " + DCMainData[0].BillAddress2 === null ? "" : DCMainData[0].BillAddress2);
            setBillCity(DCMainData[0].BillCity === null ? "" : DCMainData[0].BillCity);
            setBillState(DCMainData[0].BillState === null ? "" : DCMainData[0].BillState);
            setBillCountry(DCMainData[0].BillCountry === null ? "" : DCMainData[0].BillCountry);
            setBillPINCode(DCMainData[0].BillPINCode === null ? "" : DCMainData[0].BillPINCode);
            setShipAddress1(DCMainData[0].ShipAddress1 === null ? "" : DCMainData[0].ShipAddress2);
            setShipAddress2(DCMainData[0].ShipAddress2 === null ? "" : DCMainData[0].ShipAddress2);
            setShipCity(DCMainData[0].ShipCity === null ? "" : DCMainData[0].ShipCity);
            setShipState(DCMainData[0].ShipState === null ? "" : DCMainData[0].ShipState);
            setShipCountry(DCMainData[0].ShipCountry === null ? "" : DCMainData[0].ShipCountry);
            setShipPINCode(DCMainData[0].ShipPINCode === null ? "" : DCMainData[0].ShipPINCode);
            setCreatedBy(DCMainData[0].CreatedBy);
        }
    }, [DCMainData]);


    return (
        <Paper elevation={3}>
            <Typography className={classes.headertext} noWrap>
                <LocalAtmIcon style={{ fontSize: 36 }} />
                Delivery Challan
                <div style={{ width: "100%" }}>
                    <div style={{ float: "right", marginTop: -3 }}>
                        <Button onClick={generateExcel} style={{ marginTop: 5, marginLeft: 5, width: "15%" }} text="RateChange" color="primary" />
                        {/* <Link
                            style={{ textDecoration: "none" }}
                            to={{
                                pathname: "/deliveryChallan",
                                state: { Account, },
                                // pageName: "header",
                            }}
                        >
                            <BiztranControls.Button text={"Prev"} />
                        </Link> */}
                        <BiztranControls.Button
                            text="Courier"
                            onClick={() => {
                                handleCourierOpenModal();
                            }} />
                        <BiztranControls.Button
                            text="POD"
                            onClick={() => {
                                handlePODOpenModal();
                            }} />
                        <BiztranControls.Button
                            text="Print"
                            onClick={() => {
                                Openurl();
                            }}
                        />
                        <BiztranControls.Button
                            text="EDIT"
                            startIcon={<EditIcon />}
                            onClick={() => {
                                handleOpenModal();
                            }} />
                    </div>

                </div>
            </Typography>
            <Grid spacing={1} container style={{ marginTop: 7, paddingLeft: 10 }}>
                <Grid item xs={12} container direction="row">
                    <Grid item xs={4} container direction="row">
                        <h5 style={{ width: 115 }}>DeliveryChallan No:</h5>
                        <h5 style={{ color: "#0096FF" }}>{DCNo + " - " + DCDate}</h5>
                    </Grid>
                    <Grid item xs={4} container direction="row">
                        <h5 style={{ width: 100 }}>Company:</h5>
                        <h5 style={{ color: "#0096FF" }}>{Company}</h5>
                    </Grid>
                    <Grid item xs={4} container direction="row">
                        <h5 style={{ width: 100 }}>Generated By:</h5>
                        <h5 style={{ color: "#0096FF" }}>{GeneratedBy}</h5>
                    </Grid>
                </Grid>
                <Grid item xs={12} container direction="row">
                    <Grid item xs={4} container direction="row">
                        <h5 style={{ width: 115 }}>Account Name:</h5>
                        <h5 style={{ color: "#0096FF" }}>{AccountName}</h5>
                    </Grid>
                    <Grid item xs={4} container direction="row">
                        <h5 style={{ width: 100 }}>Handled By:</h5>
                        <h5 style={{ color: "#0096FF" }}>{HandledBy}</h5>
                    </Grid>
                </Grid>
                <Grid item xs={12} container direction="row">
                    <Grid item xs={4} container direction="row">
                        <h5 style={{ width: 100 }}>Billing Address:</h5>
                        <h5 style={{ color: "#0096FF" }}>{BillAddress + " " + BillCity}</h5>
                        {/* <Grid item xs={3} container direction="row"> */}
                        <h5 style={{ width: 100, color: "#0096FF" }}> {BillState + " " + BillCountry + " " + BillPINCode}</h5> </Grid>
                    {/* </Grid> */}
                    <Grid item xs={4} container direction="row">
                        <h5 style={{ width: 100 }}>Ship Address:</h5>
                        <h5 style={{ color: "#0096FF" }}>{ShipAddress1 + " " + ShipAddress2 + " " + ShipCity}</h5>
                        {/* <Grid item xs={3} container direction="row"> */}
                        <h5 style={{ width: 100, color: "#0096FF" }}> {ShipState + " " + ShipCountry + " " + ShipPINCode}</h5></Grid>
                    {/* </Grid> */}
                </Grid>
            </Grid>
            <ModalFrame
                title="Delivery Challan Details"
                maxWidth="md"
                isOpen={isOpen}
                setOpen={setOpen}
            >
                <CreateDeliveryChallan
                    DeliveryChallanID={DCID}
                    setOpen={setOpen}
                    DCMainData={DCMainData}
                    Mode={Mode}
                    PopulateData={PopulateData}
                    cmbLeadSourceData={cmbLeadSourceData}
                    cmbCountryData={cmbCountryData}
                    cmbCompanyData={cmbCompanyData}
                />
            </ModalFrame>

            <ModalFrame
                title="Courier Details"
                maxWidth="sm"
                isOpen={isCourierOpen}
                setOpen={setCourierOpen}
            >
                <CourierDetails
                    DeliveryChallanID={DCID}
                    // DCMainData={DCMainData}
                    setCourierOpen={setCourierOpen}
                    Mode={Mode}
                    PopulateData={PopulateData}
                />
            </ModalFrame>
            <ModalFrame
                title="POD Details"
                maxWidth="sm"
                isOpen={isPODOpen}
                setOpen={setPODOpen}
            >
                <CreatePOD
                    DeliveryChallanID={DCID}
                    setPODOpen={setPODOpen}
                    Mode={Mode}
                    PopulateData={PopulateData}
                />
            </ModalFrame>
        </Paper>
    );
};
const useStyles = makeStyles((theme) => ({
    header: {
        width: "100%",
        background: "#e6d8d8", //theme.palette.tertiary.gradient,
        color: "#3d3d3d",
        height: "2.7rem",
        fontSize: "1.8rem",
        marginTop: "4.2rem",
        display: "flex",
        flexDirection: "row",
    },
    headertext: {
        background: "#e6d8d8", //theme.palette.tertiary.gradient,
        color: "#3d3d3d",
        height: "2.7rem",
        fontSize: "1.8rem",
        marginTop: "4.3rem",
        display: "flex",
        flexDirection: "row",
    },
    headerCmn: {
        background: "#e6d8d8", //theme.palette.tertiary.gradient,
        color: "#3d3d3d",
        height: "2rem",
        fontSize: "1rem",
        display: "flex",
        flexDirection: "row",
        margin: "0.3rem",
        fontWeight: "bold",
    },
}));

export default DCHeaderView;
